import React from "react";
import Combobox from "../Combobox";
import translate from "../../../../../utils/Translator";

const Holders = (props) => {
  const items = () => {
    if (props.items == null) {
      return [
        {
          id: props.value,
          description: props.name,
        },
      ];
    }

    return props.items;
  };

  const isDisabled = props.disabled || !props.items;

  return (
    <Combobox
      emptyLabel={`${translate("Account")} holder`}
      {...props}
      disabled={isDisabled}
      items={items()}
    />
  );
};

export default Holders;
